import { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { ListCell } from '@src/components/table-list/cells'
import { ProgressBar } from '@src/elements/progress-bar/progress-bar'
import { Body2 } from '@src/elements/typography/typography'
import Member from '@src/data/member'

@Component
export class ProgressCell extends ListCell {
  item: Member

  render (h: CreateElement) {
    const trainingDays = this.item.detailsLoaded ? this.item.trainingPlanProgress : null
    if (!trainingDays) return <div class='cell progress-cell' />

    return <div class='cell progress-cell'>
      <ProgressBar progress={this.item.trainingProgress * 100} />

      <Body2>{`${trainingDays.completed} / ${trainingDays.total} ${this.$t('WORKOUTS')}`}</Body2>
    </div>
  }
}
